import React from 'react'
import { useForm } from 'react-hook-form'
import Card from '../components/Card'
import { ERROR_DICT, errorDict } from '../utils/errorDict'
import TextField from '../components/TextField'
import { useAxios } from '../hooks/useAxios'
import { changePassword } from '../api/changePassword'
import Btn from '../components/Btn'
import { toast } from 'react-toastify'

function ProfileEditPasswordChangePage(): React.ReactElement {
  const {
    control,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm()
  const { error, fire, loading } = useAxios()

  const onSubmit = async (data: any): Promise<void> => {
    const { error } = await fire(
      changePassword({
        newPassword: data.newPassword,
        password: data.password,
      }),
    )

    if (!error) {
      toast.success('Пароль успешно изменен')
      reset()
    }
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Card>
        <header className={'card-head text-h3'}>Смена пароля</header>
        <div className={'card-content'}>
          <TextField
            autocomplete={'on'}
            name="password"
            control={control}
            rules={{ required: true }}
            hasError={!!errors.password || !!error}
            errorText={errorDict(errors.password) || error?.message}
            type={'password'}
            label={'Старый пароль'}
            required
          ></TextField>
          <TextField
            autocomplete={'on'}
            name="newPassword"
            control={control}
            helpText={'Не менее 6 символов'}
            rules={{
              required: true,
              minLength: 6,
              validate: (value, formValues) => value !== formValues.password,
            }}
            hasError={!!errors.newPassword}
            errorText={
              errors.newPassword?.type === 'minLength'
                ? ERROR_DICT.passwordMinLength
                : errors.newPassword?.type === 'validate'
                  ? ERROR_DICT.passwordsShouldNotMatches
                  : errorDict(errors.newPassword)
            }
            type={'password'}
            label={'Новый пароль'}
            required
          ></TextField>
          <TextField
            autocomplete={'on'}
            name="newPasswordRepeat"
            control={control}
            rules={{
              required: true,
              validate: (value, formValues) => {
                const { newPassword } = formValues

                return value === newPassword
              },
            }}
            hasError={!!errors.newPasswordRepeat}
            errorText={
              errors.newPasswordRepeat?.type === 'validate'
                ? ERROR_DICT.passwordsMatches
                : errorDict(errors.newPasswordRepeat)
            }
            type={'password'}
            label={'Повторите новый пароль'}
            required
          ></TextField>
        </div>
      </Card>

      <Btn
        className={'mt-md-8 mt-sm-6'}
        disabled={loading}
        loading={loading}
        type={'submit'}
      >
        Изменить пароль
      </Btn>
    </form>
  )
}

export default ProfileEditPasswordChangePage
